/**
 * The timestamp column both history lists render.
 *
 * With a todayLabel: Today / Mon / 28 Jun — recent rows read as "when", older ones as a date.
 * Without one: always the short date, which is what a version list wants (every row is old, and
 * "Today" beside three of them tells the reader nothing).
 *
 * Returns '' rather than a placeholder for a missing or unparseable timestamp, so the caller's
 * layout simply omits the column instead of showing "Invalid Date".
 */
export function historyDateLabel(raw: any, todayLabel?: string, locale?: string): string {
  if (!raw) { return ''; }
  const when = new Date(raw);
  if (isNaN(when.getTime())) { return ''; }

  if (todayLabel) {
    const now = new Date();
    if (when.toDateString() === now.toDateString()) { return todayLabel; }
    if ((now.getTime() - when.getTime()) / 86400000 < 7) {
      return when.toLocaleDateString(locale || undefined, { weekday: 'short' });
    }
  }
  return when.toLocaleDateString(locale || undefined, { day: 'numeric', month: 'short' });
}
